const TransactionIcon = ({ size = 24, fill = '#4F4C4D' }: { size?: number; fill?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="white" />
      <path
        d="M18.3 21H5.7C4.20884 21 3 19.7912 3 18.3V3.9C3 3.40295 3.40295 3 3.9 3H16.5C16.9971 3 17.4 3.40295 17.4 3.9V14.7H21V18.3C21 19.7912 19.7912 21 18.3 21ZM17.4 16.5V18.3C17.4 18.7971 17.8029 19.2 18.3 19.2C18.7971 19.2 19.2 18.7971 19.2 18.3V16.5H17.4ZM15.6 19.2V4.8H4.8V18.3C4.8 18.7971 5.20295 19.2 5.7 19.2H15.6ZM6.6 7.5H13.8V9.3H6.6V7.5ZM6.6 11.1H13.8V12.9H6.6V11.1ZM6.6 14.7H11.1V16.5H6.6V14.7Z"
        fill={fill}
      />
    </svg>
  );
};

export default TransactionIcon;
